import React from 'react'
import { motion } from 'framer-motion'
import {
  FaHiking,
  FaBicycle,
  FaSkiing,
  FaSkiingNordic,
  FaSwimmer,
  FaBinoculars,
  FaLandmark,
  FaChild
} from 'react-icons/fa'
import './Activities.css'

const Activities = () => {
  const activities = [
    {
      icon: FaHiking,
      title: 'Turistika',
      description: 'Hřeben Orlických hor, bunkry a rozhledy',
      details:
        'Trasa ze Zdobnice přes Pěticestí na Velkou Deštnou s rozhlednou. Značené trasy, krásné výhledy.'
    },
    {
      icon: FaBicycle,
      title: 'Cyklistika',
      description: 'Cyklookruhy a přejezdy hřebenem',
      details:
        'Napojení na cyklotrasu 4070 přes Pěticestí a Luisino údolí. Terén vhodný i pro rodiny.'
    },
    {
      icon: FaBicycle,
      title: 'Singletrack Zdobnice',
      description: 'Zábavné lesní stezky pro MTB',
      details:
        'Více než 10 km jednosměrných flow trailů různé obtížnosti v okolí Zdobnice.'
    },
    {
      icon: FaChild,
      title: 'Dětské hřiště a pumptrack',
      description: 'Moderní hřiště přímo v obci',
      details:
        'Nové veřejné dětské hřiště se samoobslužným barem, hned u pumptracku a tréninkové trasy pro singletrack.'
    },
    {
      icon: FaSkiing,
      title: 'Sjezdové lyžování',
      description: 'Ski centrum Zdobnice v obci',
      details:
        'Areál nabízí několik sjezdovek, vleky a večerní lyžování. Půjčovna a občerstvení v provozu.'
    },
    {
      icon: FaSkiingNordic,
      title: 'Běžky',
      description: 'Zdobnický okruh 9 km (upravovaný)',
      details:
        'Nástup u kostela nebo u horní stanice vleku. Napojení na orlickohorskou magistrálu.'
    },
    {
      icon: FaSwimmer,
      title: 'Koupání',
      description: 'Přehrada Pastviny a okolní koupaliště',
      details:
        'Letní koupání, vodní sporty a půjčovny u Pastvin (dojezd autem).'
    },
    {
      icon: FaBinoculars,
      title: 'Vyhlídky a rozhledny',
      description: 'Velká Deštná a hřebenová panoramata',
      details:
        'Rozhledna na Velké Deštné s výhledy na celé Orlické hory.'
    },
    {
      icon: FaLandmark,
      title: 'Památky v okolí',
      description: 'Zámky a pevnosti v Podorlicku',
      details:
        'Potštejn, Opočno, Kuks, vojenské pevnosti a další cíle na jednodenní výlety.'
    }
  ]

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 }
    }
  }

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 }
    }
  }

  return (
    <section className="activities-section section">
      <div className="container">
        <motion.div
          className="activities-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h1 className="section-title">Aktivity</h1>
          <p className="section-subtitle">
            Co můžete dělat v okolí naší chaty
          </p>
        </motion.div>

        <motion.div
          className="activities-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {activities.map(({ icon: Icon, title, description, details }, i) => (
            <motion.div
              key={i}
              className="activity-card"
              variants={itemVariants}
              whileHover={{ scale: 1.05, transition: { duration: 0.2 } }}
            >
              <div className="activity-icon">
                <Icon />
              </div>
              <h3 className="activity-title">{title}</h3>
              <p className="activity-description">{description}</p>
              <div className="activity-details">
                <p>{details}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  )
}

export default Activities
